import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=397f1005&scoped=true"
var script = {}
import style0 from "./Info.vue?vue&type=style&index=0&id=397f1005&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397f1005",
  null
  
)

export default component.exports